<template>
  <div class="footer">
    <div class="head">
      <div id="sect1">
        <img id="logo-footer" src="../../../public/assets/logo-insis.png" />
      </div>
      <div id="sect2">
        <h2>{{$t("action.contactUs")}}</h2>
        <a href="mailto:marco.vettucci@insis.it">marco.vettucci@insis.it</a>
      </div>
      <div id="sect3">
        <h2>{{$t("action.callUs")}}</h2>
        <a href="tel:+393426486115">+39 342 648 6115</a>
        <p>
          {{$t("day.monday").substring(0, 3)}}. - {{$t("day.friday").substring(0, 3)}}. | 9am - 6pm
        </p>
      </div>
    </div>
    <div class="bottom">
      <p><strong>INSIS SPA </strong>powered By Move Solutions.</p>
    </div>
  </div>
</template>
<script>
export default {
  name: "footer-move",
};
</script>
<style scoped>
p {
  margin: 0;
}

a {
  color: white;
}

.head {
  grid-row: 1;
  display: grid;
  grid-template-columns: 33% 33% 33%;
}
.bottom {
  border-top: solid 2px rgba(80, 84, 105, 1);
  width: 90%;
  display: flex;
  justify-self: center;
  grid-row-start: 1;
  grid-row-end: 4;
  grid-row: 2;
  justify-content: center;
  align-items: center;
}

.bottom > p {
  font-size: 0.7rem;
}

.footer {
  background-color: rgb(45, 48, 65);
  display: grid;
  grid-template-rows: 80% 20%;
  width: 100%;
  height: 150px;
  margin-top: 20px;
  text-align: left;
  font-size: 0.82em;
  align-content: center;
}
#sect1 {
  grid-column: 1;
  align-items: center;
  justify-content: center;
  margin-top: auto;
  margin-bottom: auto;
  display: flex;
}
#logo-footer {
  width: 200px;
  padding-top: 20px;
  padding-bottom: 40px;
}

#sect2 {
  grid-column: 2;
  margin-top: auto;
  margin-bottom: auto;
  padding-left: 30%;
}

#sect3 {
  grid-column: 3;
  margin-top: auto;
  margin-bottom: auto;
  padding-left: 30%;
}
</style>
